import React from 'react'
import { RendererProps } from '../types'
import _ from 'lodash'

const getAppContext = _.once(() => React.createContext<RendererProps>({} as RendererProps))

export default getAppContext
